const Flex = require('components/Flex/Flex');
module.exports = Flex;
